
      import '@folkjs/labs/standalone/folk-space-attribute';
      import '@folkjs/labs/standalone/folk-shape-attribute';
      import { dragImageOutOfVideoFrame } from '@folkjs/labs/interactions/video';

      let ac = null;
      const main = document.querySelector('main');
      const pluck = document.querySelector('button');
      const video = document.querySelector('video');

      pluck.addEventListener('click', async () => {
        if (ac) {
          ac?.abort();
        } else {
          ac = new AbortController();
          await dragImageOutOfVideoFrame(ac.signal, main);
          ac = null;
        }
      });

      document.body.addEventListener('dblclick', (e) => {
        const figure = e.target.closest('figure');

        if (figure === null) return;
        const time = figure.querySelector('figcaption')?.textContent;

        if (time) {
          video.currentTime = Number(time);
        }
      });
    